import React, { useEffect, useState } from "react";
import { X, Loader2, Gift } from "lucide-react";
import { AdManager } from "../game/ads";

// Global ad overlay — shows ONLY the real AdSense unit. On the live, approved
// domain (with a configured ad slot) a real ad is served; in preview the slot
// stays empty by design. Rewards are always validated server-side.
export default function AdHost() {
  const [ad, setAd] = useState(null); // { kind, seconds, resolve }
  const [left, setLeft] = useState(0);

  useEffect(() => { AdManager._setPresenter((opts) => setAd(opts)); }, []);

  useEffect(() => {
    if (!ad) return;
    setLeft(ad.seconds);
    if (AdManager.networkActive) { try { AdManager.pushAd(); } catch (e) { console.warn(e); } }
    const iv = setInterval(() => setLeft((l) => { if (l <= 1) { clearInterval(iv); return 0; } return l - 1; }), 1000);
    return () => clearInterval(iv);
  }, [ad]);

  if (!ad) return null;
  const rewarded = ad.kind === "rewarded";
  const canClose = left <= 0;
  const useAdSense = AdManager.networkActive && AdManager.interstitialSlot;

  const finish = () => { const r = ad.resolve; setAd(null); r && r({ completed: true }); };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 backdrop-blur-sm p-4" data-testid="ad-overlay">
      <div className="w-full max-w-sm pop-in">
        <div className="flex items-center justify-between mb-2 px-1">
          <span className="text-[10px] uppercase tracking-widest text-slate-400 font-bold">Advertisement</span>
          <button
            onClick={canClose ? finish : undefined}
            disabled={!canClose}
            className={`text-xs font-bold flex items-center gap-1 rounded-full px-2.5 py-1 transition-colors ${canClose ? "text-white bg-slate-700/80 hover:bg-slate-600 pointer-events-auto" : "text-slate-500 bg-slate-800/60 cursor-default"}`}
            data-testid="ad-skip"
          >
            {canClose ? <><X size={13} /> {rewarded ? "Close" : "Skip"}</> : `${rewarded ? "Reward" : "Skip"} in ${left}s`}
          </button>
        </div>

        <div className="rounded-2xl bg-slate-900 border border-slate-700 overflow-hidden flex items-center justify-center min-h-[250px]">
          {useAdSense ? (
            <ins className="adsbygoogle" style={{ display: "inline-block", width: 300, height: 250 }}
              data-ad-client={AdManager.publisherId} data-ad-slot={AdManager.interstitialSlot}
              data-testid="adsense-unit" />
          ) : (
            <div className="w-[300px] h-[250px] flex flex-col items-center justify-center text-center p-6" data-testid="ad-placeholder">
              <Loader2 size={30} className="text-slate-500 animate-spin mb-3" />
              <div className="text-slate-300 font-bold">Your ad will appear here</div>
              <div className="text-slate-500 text-xs mt-1">
                {AdManager.networkActive ? "Loading sponsored ad…" : "Ads are served on the live site"}
              </div>
            </div>
          )}
        </div>

        <div className="text-center text-[11px] text-slate-400 mt-2 flex items-center justify-center gap-1">
          {rewarded ? (<><Gift size={12} className="text-amber-400" /> Watch to earn your reward</>) : "Your match loads right after this ad"}
        </div>
      </div>
    </div>
  );
}
